import React, { useState, useRef, useEffect, useContext } from "react";
//@ts-ignore
import classnames from "classnames";
import api from "../../../../../services/api";
import AuthContext from "../../../../../contexts/Auth";
import SimpleHeader from "../../../../../components/Headers/SimpleHeader";


import Pilares from "./Pilares";
import Destinos from "./Veiculacoes";
import Calibragens from "./Calibragens";

//@ts-ignore
import NotificationAlert from "react-notification-alert";
import { HeaderContainer } from "./styles";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Nav,
  Row,
  Col,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Button,
} from "reactstrap";
import EmpresaContext from "../../../../../contexts/Empresa";

// empresaId,
//   history,
//   hiddeTabs = {},
//   externaTabActive,
//   minhaEmpresa,
//   ...props

interface Props {
  hiddeTabs?: any
  props?: any
  history?: any
}

const MidiasSociais: React.FC<Props> = ({ hiddeTabs, props, history }) => {

  const [empresa, setEmpresa] = useState({});
  const [tabActive, setTabActive] = useState("pilares");
  const [headerContent, setHeaderContent] = useState<any>(null);
  const [alert, setAlert] = useState(null);
  const notificationAlert = useRef<any>();
  const { empresaSelecionada } = useContext<any>(EmpresaContext)
  const { hasPermission, hasRole } = useContext(AuthContext);

  // useEffect(() => {
  //   if (externaTabActive && externaTabActive.length > 0) {
  //     setTabActive(externaTabActive);
  //   }
  // }, [externaTabActive]);

  // async function loadEmpresa(empresaId:number) {
  //   try {
  //     const response = await api.get(`/common/empresas/${empresaId}`);
  //     setEmpresa(response?.data);
  //   } catch (error) {
  //     console.log(error);
  //     notify("danger", "Não foi possível carregar empresa");
  //   }
  // }

  const notify = (type: any, msg: string) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text" style={{ zIndex: 100 }}>
          <span data-notify="message">{msg}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 3,
    };
    if (notificationAlert.current)
      notificationAlert.current.notificationAlert(options);
  };

  function onEmpresaChange(empresa: any) {
    setEmpresa(empresa ? empresa : {});
  }

  const CustomNavItem = ({ children, disabled, name }: any) => {
    return (
      <>
        <NavItem>
          <NavLink
            href="#"
            role="tab"
            className={classnames("mb-sm-3 mb-md-0 mt-2", {
              active: tabActive === name,
            })}
            onClick={() => setTabActive(name)}
            disabled={disabled}
          >
            {children}
          </NavLink>
        </NavItem>

      </>
    );
  };

  return (
    <>
      {alert}
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <SimpleHeader name="Configurações de publicações" parentName="Minha empresa" />
      <div className="w-100">
        <Card>
          <CardHeader>
            {headerContent ? headerContent : (
               <div className="d-flex justify-content-between align-items-center">
                <h1 className="mb-0">Mídias sociais</h1>
               </div>
            )}
          </CardHeader>
          <CardBody outline body>
            <Row>
              <Col xs={12} lg={12} md={12} sm={12}>
                <div className="nav-wrapper">
                  <Nav
                    className="nav-fill flex-column flex-md-row"
                    pills
                    role="tablist"
                  >
                    {/* <CustomNavItem name="marcacoes" disabled={!empresaSelecionada.id}>
                      <>
                        <i className="fas fa-hashtag mr-2" />
                        Marcações
                      </>
                    </CustomNavItem> */}
                    <CustomNavItem name="pilares" disabled={!empresaSelecionada.id}>
                      <>
                        <i className="fas fa-layer-group mr-2 mt-2" />
                        Pilares
                      </>
                    </CustomNavItem>
                    <CustomNavItem name="calibragens" disabled={!empresaSelecionada.id}>
                      <>
                        <i className="fas fa-sort mr-2" />
                        Calibragens
                      </>
                    </CustomNavItem>
                    <CustomNavItem name="destinos" disabled={!empresaSelecionada.id}>
                      <>
                        <i className="fas fa-share-alt mr-2" />
                        Destinos
                      </>
                    </CustomNavItem>
                  </Nav>
                </div>
                <hr className="m-0" />
                <div>
                  <TabContent activeTab={tabActive}>
                    {/* <TabPane tabId="marcacoes">
                      {empresaSelecionada.id && (
                        <MarcacaoForm
                          {...props}
                          history={history}
                          onEmpresaChange={onEmpresaChange}
                          notify={notify}
                          empresa={empresaSelecionada}
                          title={'Marcação'}
                          aplicacao={'P'} />
                      )}
                    </TabPane> */}
                    <TabPane tabId="pilares">
                      {tabActive === "pilares" && empresaSelecionada.id && (
                        <Pilares
                          {...props}
                          history={history}
                          onEmpresaChange={onEmpresaChange}
                          notify={notify}
                          empresa={empresaSelecionada}
                          isActive={tabActive === "pilares"}
                          setHeaderContent={setHeaderContent}
                        />
                      )}
                    </TabPane>
                    <TabPane tabId="destinos">
                      {tabActive === "destinos" && empresaSelecionada.id && (
                        <Destinos
                          {...props}
                          history={history}
                          onEmpresaChange={onEmpresaChange}
                          notify={notify}
                          empresa={empresaSelecionada}
                          isActive={tabActive === "destinos"}
                          setHeaderContent={setHeaderContent}
                        />
                      )}
                    </TabPane>
                    <TabPane tabId="calibragens">
                      {tabActive === "calibragens" && empresaSelecionada.id && (
                        <Calibragens
                          {...props}
                          history={history}
                          onEmpresaChange={onEmpresaChange}
                          notify={notify}
                          empresa={empresaSelecionada}
                          isActive={tabActive === "calibragens"}
                          setHeaderContent={setHeaderContent}
                        />
                      )}
                    </TabPane>
                  </TabContent>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
export default MidiasSociais;
